const puzzle = {
  id: "B9DtXQ4e9mnsFuCu4ylP",
  name: "A rich man, a poor boy and just a teenager",
  rebuses: [
    {
      id: "20640897-30ce-4fff-98f1-210a521bbe6d",
      style: {},
      solutionInfo: {
        possibleSolutions: [
          {
            value: "Queen",
            id: "2fdbd916-3f93-4938-b6f1-b0418e01376c",
          },
        ],
        type: "text",
        solvedText: "Queen",
      },
      clues: [
        {
          solutionInfo: {
            type: "text",
            solvedText: "Australia",
            possibleSolutions: [
              {
                id: "49dee4f5-85b2-4f32-add4-6fe9e74ccd22",
                value: "Australia",
              },
            ],
          },
          subtext: "",
          dependsOn: [],
          clueGroup: 1,
          helperText: "It's also a continent.",
          clueValues: [
            {
              value: "6T8XI2Pz.png",
              id: "f7a34759-9040-450c-870f-4f8634fea9d0",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              type: "image",
            },
          ],
          id: "7baf8c7b-b10d-4946-868b-1453292e9c1f",
          style: {
            width: "calc(33% - 10px)",
          },
        },
        {
          helperText: "There's a statue of Jesus looking over it.",
          subtext: "",
          solutionInfo: {
            solvedText: "Rio de Janeiro",
            possibleSolutions: [
              {
                id: "087a79f3-fa9c-4bd2-acf3-6c00a0e9d94f",
                value: "Rio de Janeiro",
              },
            ],
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          dependsOn: [],
          id: "dde2a693-b698-4379-b4e1-bf8959f78f41",
          clueGroup: 2,
          clueValues: [
            {
              subtext: "",
              id: "c148ef28-eebd-4625-b697-b248b07e1bdf",
              style: {
                width: "calc(100% - 10px)",
              },
              value: "L6gJALQU.png",
              type: "image",
            },
          ],
        },
        {
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          clueValues: [
            {
              subtext: "",
              id: "b138d08b-da27-4566-a5f1-3d187dbae149",
              value: "qDo8V1se.png",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText:
            "It's a previous version of a logo of a football stadium in London.",
          clueGroup: 3,
          id: "bfdcf6d4-0c28-4a6a-b7d2-82cb5be069b5",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "aa76b94b-c2a2-4ef7-ae32-c6c0a957ff08",
                value: "Wembley",
              },
            ],
            solvedText: "Wembley",
          },
        },
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              value: "1985.",
              id: "f186ca9d-ff4f-414e-aeaa-a678e89d69df",
              subtext: "Rock band",
            },
          ],
          dependsOn: [
            {
              value: "7baf8c7b-b10d-4946-868b-1453292e9c1f",
              id: "0ec10018-9a07-415b-ad6d-be3a2746440c",
            },
            {
              id: "be5f389e-1ea1-4c62-a708-17c68a4ff344",
              value: "dde2a693-b698-4379-b4e1-bf8959f78f41",
            },
            {
              value: "bfdcf6d4-0c28-4a6a-b7d2-82cb5be069b5",
              id: "8b4261be-a549-42e1-b0c2-e861e2fb1f28",
            },
          ],
          id: "e80a852e-3037-461f-a8e9-595d4819fd4d",
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "A certain band was playing at these locations in 1985.",
          subtext: "",
          clueGroup: 0,
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
        },
      ],
    },
    {
      id: "ac4f4859-cbe2-4eb3-bcba-f2b9583e8a24",
      solutionInfo: {
        possibleSolutions: [
          {
            id: "7352e9d0-48e8-4822-910b-e6f19a08faa4",
            value: "Twist",
          },
        ],
        solvedText: "Twist",
        type: "text",
      },
      clues: [
        {
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              type: "image",
              value: "qt8HWYfk.png",
              subtext: "",
              id: "ed9be914-2908-4c3f-b9b0-5836fcfc83b4",
            },
          ],
          dependsOn: [],
          style: {
            width: "calc(32% - 10px)",
          },
          subtext: "",
          clueGroup: 1,
          id: "d8763c67-eb3c-48d3-9756-9854b2cd9e78",
          helperText:
            "Look up a flag semaphore and find corresponding letters.",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                id: "04af5efd-0f4b-4b33-994c-83241a8f6757",
                value: "Arm",
              },
            ],
            solvedText: "Arm",
          },
        },
        {
          helperText: "Full names of these events. Synonim for plan.",
          dependsOn: [],
          id: "66ca0b72-80ca-4e33-8037-dbe936bf4e22",
          solutionInfo: {
            possibleSolutions: [
              {
                id: "bd87d3f2-8c96-4fa6-b289-8ee9a84e2153",
                value: "Plot",
              },
            ],
            type: "text",
            solvedText: "Plot",
          },
          clueGroup: 2,
          style: {
            width: "calc(40% - 10px)",
          },
          subtext: "",
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "8d9568e0-fcdd-4514-b445-8d50acdd20c2",
              value: "July 20 (1944.)",
              subtext: "",
              type: "text",
            },
            {
              style: {
                width: "calc(100% - 10px)",
              },
              id: "22222-fcdd-4514-b445-8d50acdd20c2",
              value: "Gunpowder (1605.)",
              subtext: "",
              type: "text",
            },
          ],
        },
        {
          subtext: "",
          id: "5a3b42a3-d9d0-4f1c-a76d-3ca101dd0644",
          helperText: "",
          style: {
            width: "calc(69% - 10px)",
          },
          dependsOn: [
            {
              value: "d8763c67-eb3c-48d3-9756-9854b2cd9e78",
              id: "62512933-cefe-46e4-82ad-e3dcf61d8fb2",
            },
            {
              id: "d680049a-be6e-42b2-b2c9-23b81afe037f",
              value: "66ca0b72-80ca-4e33-8037-dbe936bf4e22",
            },
          ],
          clueValues: [
            {
              id: "4c04a8e9-10fe-4b5c-a334-346f2557fa04",
              subtext: "",
              value:
                "Arm: to grab someone's arm and bend it in order to cause pain",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
            },
          ],
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueGroup: 1,
        },
        {
          dependsOn: [
            {
              id: "bc1883a8-9924-48b9-a738-e28b99c48f6d",
              value: "66ca0b72-80ca-4e33-8037-dbe936bf4e22",
            },
            {
              id: "d2270c55-871a-45c6-92e2-13fbc6b61ba9",
              value: "d8763c67-eb3c-48d3-9756-9854b2cd9e78",
            },
          ],
          clueValues: [
            {
              type: "text",
              subtext: "",
              value: "Plot: an unexpected turn in a story",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "c0b8e519-862f-46d6-b6da-83e06fa4f00c",
            },
          ],
          subtext: "",
          id: "9953422f-4a91-43e4-af93-b24824dc9413",
          clueGroup: 2,
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          helperText: "",
          style: {
            width: "calc(69% - 10px)",
          },
        },
      ],
      style: {},
    },
    {
      style: {},
      solutionInfo: {
        possibleSolutions: [
          {
            id: "d55b2568-f9e9-430a-bb35-4dcc2883efee",
            value: "Wood",
          },
        ],
        type: "text",
        solvedText: "Wood",
      },
      id: "4fa3f90e-a5fd-4980-873d-7c9fbffccf04",
      clues: [
        {
          subtext: "",
          dependsOn: [],
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "05fab6af-6c4b-4d36-84c9-92b44a708612",
              type: "image",
              value: "1eDxnQPP.png",
            },
          ],
          style: {
            width: "calc(32% - 10px)",
          },
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueGroup: 0,
          helperText:
            "It's the last name of an actor playing a ring bearer from The Lord of the Rings.",
          id: "ecb5743a-a450-4b56-b752-8471bd19de38",
        },
      ],
    },
    {
      id: "db372e14-988b-4708-b52a-8cfb64880df0",
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            value: "Oliver",
            id: "052af187-8d45-4e31-be49-a8be10969d16",
          },
        ],
        solvedText: "Oliver",
      },
      style: {},
      clues: [
        {
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          helperText: "First name of the main character in the TV show Arrow.",
          clueGroup: 0,
          subtext: "",
          clueValues: [
            {
              type: "text",
              id: "9b764d9d-607c-4698-8050-1df2c6bd2151",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "Arrow (TV Series)",
              value: "Queen",
            },
          ],
          dependsOn: [],
          id: "927d144b-a9d7-42e2-a1b0-376bc7202f88",
        },
        {
          subtext: "",
          solutionInfo: {
            possibleSolutions: [],
            solvedText: "",
            type: "text",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              value: "Twist",
              type: "text",
              subtext: "Book",
              id: "521a60d9-28da-4315-bc1d-dfcc8e74641a",
            },
          ],
          id: "626e8ffd-bb53-404f-8f34-a851559acc01",
          dependsOn: [],
          clueGroup: 0,
          helperText:
            "First name of the main character from a book written by Charles Dickens.",
        },
        {
          solutionInfo: {
            possibleSolutions: [],
            type: "text",
            solvedText: "",
          },
          clueGroup: 0,
          clueValues: [
            {
              id: "8367d07d-5ba8-4370-9f78-ae8d9e0a5332",
              value: "Wood",
              style: {
                width: "calc(100% - 10px)",
              },
              type: "text",
              subtext: "Harry Potter books",
            },
          ],
          subtext: "",
          id: "bdb5d9dd-afca-49cc-94d3-eb0422c5ab61",
          helperText:
            "Captain for the Gryffindor Quidditch team in Harry Potter books.",
          dependsOn: [],
          style: {
            width: "calc(33% - 10px)",
          },
        },
      ],
    },
  ],
};

export default puzzle;
